exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-select {\n  width: 90%;\n}\n.single-select .multiselect__select::before {\n  display: none;\n}\n.status-processing-import-file {\n  background: orange;\n  color: #fff;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  padding: 10px;\n  display: flex;\n}\n.status-processing-import-file span {\n  padding-left: 10px;\n}\n.status-processing-import-file .spinner-border {\n  color: #fff !important;\n  margin-top: 12px;\n}", ""]);

// exports
